export default __webpack_public_path__ + "static/media/image.lanka-market.bc54769c.png";